import { IAccountNotification, IApplicationState, IBonus, setWheelNotificationBonus } from '@spinwise/spinwise-core';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EWheelBundleImages } from './types';
/**
 * Returns an object if a bonus is available: { show: boolean, notification: INotificationReduxData },
 * or null otherwise.
 *
 * If the user has a BONUS_RNDM notification, this hook will
 * return { show: true,  notification: INotificationReduxData }
 *
 * If the user closes the overlay, it will return { show: false, notification: INotificationReduxData }.
 *
 * need to reset on spin wheel
 */
export interface IWheelBonusNotificationState {
  show?: boolean;
  allNotifications?: Array<{
    notification: IAccountNotification;
    bundleJackpot: IBonus;
  }>;
  loading: boolean;
}
const useWheelNotificationBonus = (): IWheelBonusNotificationState => {
  /*
  0.User gets a BONUS_RNDM notification after successful deposit
  1.Get notifications from status, save them to state, and request BONUS_RNDM.
  2.On notify change, request BONUS_RNDM again.
  3.Do not request BONUS_RNDM if wheelNotificationBonus is not null.
  4.If the user does not have a notification, they have probably already processed it.
  Then, you need to check the useHasNotSelectedBonus hook — it should return the data for replay_random if not,
  then the user doesn't have a bonus.
  */

  const dispatch = useDispatch();
  const wheelNotificationBonus = useSelector((state: IApplicationState) => state?.wheelReducer?.wheelNotificationBonus);
  const notify = useSelector((state: IApplicationState) => state.accountReducer.info.notify);
  const authSuccess = useSelector((state: IApplicationState) => state.authReducer.auth?.success);

  const [prevNotify, setPrevNotify] = useState(notify);
  const [loading, setLoading] = useState(false);
  const getWheelBonusNotifications = async (): Promise<any> =>
    axios.get(`/api/account/notifications`, {
      params: {
        keyword: ['BONUS_RNDM'],
        processed: false,
        markViewed: 0,
      },
    });

  const checkBonusRandomNotification = () => {
    if (!authSuccess) return;
    if (loading) return;
    setLoading(true);
    getWheelBonusNotifications().then(n => {
      const messages: Array<IAccountNotification> = n?.data?.notifications;
      const bonusRandomExist = messages?.[0];
      setLoading(false);
      if (!bonusRandomExist) {
        setWheelNotificationBonus(null)(dispatch);
        return;
      }
      // bonus exist ...
      const allNotifications =
        messages
          ?.filter(m => m?.bundles)
          .map?.((messageNotification: IAccountNotification) => ({
            notification: messageNotification,
            bundleJackpot: messageNotification.bundles?.find?.(b => b.image === EWheelBundleImages.JACKPOT) ?? null,
          })) ?? null;

      setWheelNotificationBonus({
        show: true,
        /** @deprecated remove */
        notification: null,
        allNotifications,
      })(dispatch);
    });
  };

  useEffect(() => {
    if (!authSuccess) return;
    if (wheelNotificationBonus?.allNotifications?.[0]) return;
    if (prevNotify?.join('') === notify?.join('')) return;

    if (!notify) return;
    setPrevNotify(notify);
    checkBonusRandomNotification();
  }, [notify, prevNotify]);

  useEffect(() => {
    if (!authSuccess) return;
    if (wheelNotificationBonus?.allNotifications?.[0] && prevNotify?.join('') === notify?.join('')) {
      setLoading(false);
      return;
    }
    checkBonusRandomNotification();
  }, []);
  return {
    ...wheelNotificationBonus,
    loading,
  };
};
export default useWheelNotificationBonus;
